<template>
  <div>
    <v-layout row
      style="overflow: hidden;"
    >
      <v-flex
        hidden-sm-and-down
      >
        <iframe src="https://targetfirst.zendesk.com/agent/dashboard" width="100%" height="100%" style="height: 1000px;"></iframe>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  created () {
  },
  methods: {
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ticketing/Zendesk.vue